import { render } from "./CreateUtenteForm.vue?vue&type=template&id=299448e9&scoped=true"
import script from "./CreateUtenteForm.vue?vue&type=script&lang=js"
export * from "./CreateUtenteForm.vue?vue&type=script&lang=js"

import "./CreateUtenteForm.vue?vue&type=style&index=0&id=299448e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299448e9"]])

export default __exports__